import { render, staticRenderFns } from "./dataDictionary.vue?vue&type=template&id=380000dc&scoped=true&"
import script from "./dataDictionary.vue?vue&type=script&lang=ts&"
export * from "./dataDictionary.vue?vue&type=script&lang=ts&"
import style0 from "./dataDictionary.vue?vue&type=style&index=0&id=380000dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380000dc",
  null
  
)

export default component.exports